module.exports = __webpack_public_path__ + "img/logo_tainan@1x.02246f9e.png";